import React__default from 'react';
import PropTypes__default from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core';

var useStyles = makeStyles(function () {
  return {
    CountryIcon: {}
  };
});
var CountryIcon = function CountryIcon(_ref) {
  var countryCode = _ref.countryCode,
    className = _ref.className,
    onClick = _ref.onClick;
  var classes = useStyles();
  return /*#__PURE__*/React__default.createElement("svg", {
    className: clsx(classes.CountryIcon, className),
    onClick: onClick
  }, /*#__PURE__*/React__default.createElement("use", {
    href: "/images/countries.svg#".concat(countryCode)
  }));
};
CountryIcon.defaultProps = {};
CountryIcon.propTypes = {
  countryCode: PropTypes__default.string,
  className: PropTypes__default.string,
  onClick: PropTypes__default.func
};

export { CountryIcon as default };
//# sourceMappingURL=CountryIcon.js.map
